import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { PartnerIndexMultiSelectComponent } from '../partners/crud-index/crud-index-multiselect.component';
import { FileMarketingType } from 'src/app/domain/registration/enums/file-marketung-type.enum';
export const RELATIVE_URL = 'marketings';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'systemName',
  'type',
  'fileType',  
  'createdAt', 
  'fileSize',
  'fileFormat',
  'marketingName',
  'actions',
  
];

export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'marketingName',
    display: 'TITULO',
    class: `marketing-name-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.IMAGE,
    link_show: true,
    property: 'image',
    display: 'IMAGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'partners',
    display: 'PARCEIRO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemName',
    display: 'SOLUÇÃO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileType', 
    display: 'TIPO DE ARQUIVO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemVersion', 
    display: 'VERSÃO DA SOLUÇÃO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'description',
    display: 'DESCRIÇÃO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileAttachment', 
    display: 'ARQUIVO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileSize',
    display: 'TAMANHO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileFormat',
    display: 'FORMATO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  }
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'PARCEIRO',
    component: PartnerIndexMultiSelectComponent,
    name: 'partners',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'TITULO',
    name: 'marketingName',
    validators: [ ],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SOLUÇÃO',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE ARQUIVO', 
    name: 'fileType',
    options: Object.values(FileMarketingType),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'VERSÃO DA SOLUÇÃO', 
    name: 'systemVersion',
    validators: [ ],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'ANEXAR ARQUIVO', 
    name: 'fileAttachment', 
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
    label: 'DESCRIÇÃO DO ARQUIVO',
    name: 'fileDescription',
    validators: [Validators.required],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
